<template>
  <div style="padding-bottom:44px">
    <van-field label="序列号" v-model="llmd01_Step2.serialNumber" placeholder="请输入序列号">
      <template #right-icon>
        <van-tag type="warning">{{jieMa}}</van-tag>
      </template>
    </van-field>
    <van-cell title="按键检查">
      <template #right-icon>
        <van-checkbox v-model="llmd01_Step2.anJianJianCha" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="屏幕检查">
      <template #right-icon>
        <van-checkbox v-model="llmd01_Step2.pingMuJianCha" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="蜂鸣器检查">
      <template #right-icon>
        <van-checkbox v-model="llmd01_Step2.fengMingQiJianCha" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="序列号解码">
      <template #right-icon>
        <van-checkbox v-model="llmd01_Step2.xuLieHaoJieMa" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="振动、泄压、抽气输出检查">
      <template #right-icon>
        <van-checkbox v-model="llmd01_Step2.zhenDongXieYaChouQi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-field label="备注" v-model="llmd01_Step2.remark"> </van-field>
    <el-button type="primary" class="footer1" icon="el-icon-view" circle @click="handlePicClick"></el-button>
    <div class="footer">
      <van-button type="info" v-show="$parent.hasPower_Step2" round block :disabled="$parent.llmd01_SignNumber.status!=0" @click="handleSave">保存</van-button>
      <van-button type="danger" v-if="$parent.llmd01_SignNumber.status==2" round block @click="$parent.cancel_void_SignNumber()">取消作废</van-button>
      <van-button type="danger" v-else-if="$parent.llmd01_SignNumber.status!=1" round block @click="$parent.void_SignNumber()">作废</van-button>

    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: ["signNumber"],
  data() {
    return {
      llmd01_Step2: {},
      jieMa: "",
    };
  },
  methods: {
    handlePicClick() {
      ImagePreview(["./images/LLMD01_Produce.png"]);
    },
    getLLMD01_Step2() {
      let that = this;
      that.axios
        .post("/LLMD01/GetLLMD01_Step2", { onlyText: that.signNumber })
        .then(function (response) {
          that.llmd01_Step2 = response.data.data;
        });
    },
    handleSave() {
      let that = this;
      that.axios
        .all([that.save_LLMD01_Step2(), that.registerSerialNumber()])
        .then(
          that.axios.spread(function (response1, response2) {
            that.llmd01_Step2 = response1.data.data;
            if (response1.data.code == 201) {
              that.$notify({ type: "warning", message: response1.data.msg });
            } else if (response2.data.code == 201) {
              that.$notify({ type: "warning", message: response2.data.msg });
            } else {
              that.$notify({ type: "success", message: response1.data.msg });
            }
            if (response2.data.code == 101) {
              that.jieMa = response2.data.msg;
            }
          })
        );
    },
    save_LLMD01_Step2() {
      let that = this;
      return that.axios.post("LLMD01/UpdateLLMD01_Step2", that.llmd01_Step2);
    },
    registerSerialNumber() {
      let that = this;
      return that.axios.post("Base_Device/Register", {
        productName: "理论密度(LLMD01)",
        productId: 1108,
        serialNumber: that.llmd01_Step2.serialNumber,
        deviceType: "LLMD01",
        companyName: "",
        ifPrint: false,
      });
    },
  },
  mounted() {
    let that = this;
    that.getLLMD01_Step2();
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
}
.footer1 {
  position: fixed;
  left: 10px;
  bottom: 50px;
}
</style>